import BusinessIcon from '@mui/icons-material/Business'
import OrganizationsCreate from './Organizations.create'
import OrganizationsEdit from './Organizations.edit'
import OrganizationsShow from './Organizations.show'
import OrganizationsList from './Organizations.list'

const resource = {
  list: OrganizationsList,
  create: OrganizationsCreate,
  edit: OrganizationsEdit,
  show: OrganizationsShow,
  icon: BusinessIcon,
}

export default resource
